<div
  class="skeleton"
  [ngStyle]="{ 
        height: height + 'px', 
        width: fullWidth ? '100%' : width + 'px', 
        margin: margin,
        'border-radius':  borderRadius,
        'min-width': minWidth,
        'min-height': minHeight,
    }"
></div>